import { render, staticRenderFns } from "./AccountantInfoModal.vue?vue&type=template&id=2dd2abd2&scoped=true&"
import script from "./AccountantInfoModal.vue?vue&type=script&lang=js&"
export * from "./AccountantInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd2abd2",
  null
  
)

export default component.exports